import { AdminSurface, PageHeader, Panel } from '../../../Components/AdminSurface';
import ChangePasswordForm from './ChangePasswordForm';

// Admin only (declared in the Admin route tree). The password change itself is re-verified server-side.
export default function SecurityPage() {
    return (
        <AdminSurface>
            <PageHeader title="Account security" sub="Manage how you sign in." />
            <Panel title="Change password">
                <ChangePasswordForm />
            </Panel>
        </AdminSurface>
    );
}
